import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRICE } from '../data/content';
const recap = ['8 volumi', '5 bonus', '500+ pagine di risorse', 'Dalla 1ª Primaria alla 3ª Media'];
const reassurances = ['Download digitale immediato', 'PDF pronti per la stampa', 'Garanzia soddisfatti o rimborsati di 7 giorni'];
export function FinalCta() {
  return <section className="relative w-full overflow-hidden bg-seyes px-8 py-24 sm:px-14 sm:py-32" data-id="element-114" data-mp="1jcljo8hbjfqd">
      <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-4 w-px bg-red-300 sm:left-8 lg:left-12" data-id="element-115" data-mp="1eebqu4j2gr7x" />
      <div className="relative mx-auto max-w-3xl text-center" data-id="element-116" data-mp="1t1wqfogqg8b3">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-117" data-mp="1o43kmwjcdgbc">
          Le tue lezioni di Arte possono essere <em className="text-red-700" data-id="element-118" data-mp="224e9xv506mue">pronte già oggi.</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-slate-900/75" data-id="element-119" data-mp="1x5b62e0remo0">
          Invece di cercare continuamente schede, salvare decine di idee, creare attività da zero e
          passare le domeniche a preparare le lezioni, puoi avere un percorso di Arte già organizzato
          per tutto l'anno. Più tempo per ciò che conta davvero:
        </p>
        <p className="mt-6 font-serif text-2xl italic leading-snug text-slate-900 sm:text-3xl" data-id="element-120" data-mp="122vd8490lgep">
          I tuoi studenti. Il tuo insegnamento. La tua vita fuori dalla scuola.
        </p>

        <ul className="mt-10 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-900/70" data-id="element-121" data-mp="162mbet0veyt9">
          {recap.map(item => <li key={item} data-id="element-122" data-mp="1ftqfuysx719u">{item}</li>)}
        </ul>

        <p className="mt-8 font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-7xl" data-id="element-123" data-mp="1fv1q9hgvf79x">{PRICE}</p>
        <p className="mt-3 text-sm text-slate-900/70" data-id="element-124" data-mp="1kv7eennxmbn9">Pagamento unico — nessun abbonamento.</p>

        <div className="mt-8 flex justify-center" data-id="element-125" data-mp="1pqmor5mqdpex">
          <CtaButton className="w-full sm:w-auto" data-id="element-126" data-mp="1tv2u95sfmutm" />
        </div>

        <ul className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-1.5 text-sm text-slate-900/70" data-id="element-127" data-mp="3qufgjxjylyvu">
          {reassurances.map(item => <li key={item} className="flex items-center gap-2" data-id="element-128" data-mp="3lwne49louude">
              <CheckIcon className="h-4 w-4 text-red-700" aria-hidden="true" data-id="element-129" data-mp="3hl93hf9gwhd" />
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}